import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiCompass, FiGlobe, FiChevronDown } = FiIcons;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const location = useLocation();

  // AVGS temporarily removed
  const navItems = [
    { name: 'Startseite', path: '/' },
    { name: 'Für Bewerber', path: '/bewerber' },
    { name: 'Für Arbeitgeber', path: '/unternehmen' },
    { name: 'Int. Fachkräfte', path: '/internationale-fachkraefte' },
    { name: 'Über uns', path: '/ueber-uns' },
  ];

  // Arabic removed, FA (Farsi/Dari) added
  const languages = ['DE', 'EN', 'TR', 'FA', 'ES', 'UK', 'RU'];
  const [currentLang, setCurrentLang] = useState('DE');

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 top-0 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          
          <div className="flex items-center">
            <Link to="/" className="flex flex-shrink-0 items-center gap-2">
              <SafeIcon icon={FiCompass} className="h-8 w-8 text-blue-900" />
              <span className="font-bold text-2xl text-blue-900 tracking-tight">
                NORDBLICK<span className="text-cyan-600 font-light hidden sm:inline"> Recruiting</span>
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden xl:flex items-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-cyan-600 ${
                  isActive(item.path) ? 'text-cyan-600 border-b-2 border-cyan-600' : 'text-slate-600'
                }`}
              >
                {item.name}
              </Link>
            ))}

            {/* Language Switcher */}
            <div className="relative">
              <button 
                onClick={() => setLangOpen(!langOpen)}
                className="flex items-center gap-1 text-slate-600 hover:text-blue-900 text-sm font-medium"
              >
                <SafeIcon icon={FiGlobe} /> {currentLang} <SafeIcon icon={FiChevronDown} className="h-3 w-3" />
              </button>
              
              {langOpen && (
                <div className="absolute right-0 mt-2 w-24 bg-white rounded-md shadow-lg py-1 border border-slate-100">
                  {languages.map(lang => (
                    <button
                      key={lang}
                      onClick={() => { setCurrentLang(lang); setLangOpen(false); }}
                      className="block w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-100"
                    >
                      {lang}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <Link 
              to="/jobs" 
              className="bg-blue-900 text-white px-5 py-2 rounded-md font-medium hover:bg-blue-800 transition-colors"
            >
              Job finden
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center xl:hidden gap-4">
            <div className="flex items-center gap-1 text-slate-600 text-sm font-medium">
              <SafeIcon icon={FiGlobe} /> {currentLang}
            </div>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-600 hover:text-blue-900 focus:outline-none bg-slate-100 p-2 rounded-md"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="xl:hidden bg-white border-t border-gray-100 max-h-[80vh] overflow-y-auto shadow-xl">
          <div className="px-4 pt-2 pb-6 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-3 rounded-md text-base font-medium ${
                  isActive(item.path) 
                    ? 'text-cyan-600 bg-blue-50' 
                    : 'text-slate-600 hover:text-blue-900 hover:bg-slate-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link 
              to="/jobs" 
              onClick={() => setIsOpen(false)}
              className="block px-3 py-3 mt-4 bg-blue-900 text-white rounded-md text-base font-medium text-center"
            >
              Zu den Stellenangeboten
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;